
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { DataGrid, GridColumnMenu, GridToolbar } from "@mui/x-data-grid";
import Loader from "../../components/common/Loader";
import Badge from "@mui/material/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMagnifyingGlass,
  faSchool,
  faUserGraduate,
  faFileSignature,
  faIdBadge,
  faEnvelope,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Modal } from "react-bootstrap";
import SecCard from "../../components/common/SecCard";
import { green, yellow, red, deepPurple } from "@mui/material/colors";
import { SERVER_ORIGIN } from "../../utilities/constants";
import {
  hasReadOnlyAccess,
  getDashboardPath,
} from "../../utilities/helper_functions";
import BackButton from "../../components/common/BackButton";
import InstituteDropDown from "../../components/common/InstituteDropDown";
import TermsAndConditionsButton from "../../components/common/TermsAndConditionsModal";
import SchoolUpload from "../../components/common/SchoolUpload";
import DownloadSchoolExcel from "../../components/common/DownloadSchoolExcel";
import css from "../../css/admin/users-page.module.css";

const AllInstitute = () => {


  const [searchParams] = useSearchParams();
  //   const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  console.log("tabFromUrl>>", tabFromUrl);
  const navigate = useNavigate();


  const [activeTab, setActiveTab] = useState(tabFromUrl || "institute");
  console.log("activeTab>>", activeTab);

  //   const [activeTab, setActiveTab] = useState("institute");
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(0);
  const [allInstitutes, setAllInstitutes] = useState([]);
  const [page, setPage] = useState(1);
  const [sortType, setSortType] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [mouStatus, setMouStatus] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedInstituteId, setSelectedInstituteId] = useState(null);
  const [termsAvailability, setTermsAvailability] = useState({});
  const [refreshCounter, setRefreshCounter] = useState(0);

  // Filter states
  const [filters, setFilters] = useState({
    region: "",
    state: "",
    onboardingStatus: "",
    emailStatus: "",
    termsStatus: "",
  });

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [userType] = useState(sessionStorage.getItem("userType") || "unknown");
  const [chapterEMs, setChapterEMs] = useState([]);
  const [selectedEM, setSelectedEM] = useState(null);
  // Thalir Cluster MOU upload stats (schools + students) keyed by instituteId
  const [clusterUploadStats, setClusterUploadStats] = useState({});
  const [clusterModalOpen, setClusterModalOpen] = useState(false);
  const [clusterModalData, setClusterModalData] = useState(null);

  const isReadOnly = hasReadOnlyAccess();

  // Get unique values for dropdowns
  const uniqueRegions = [
    ...new Set(allInstitutes.map((item) => item.region).filter(Boolean)),
  ];
  const uniqueStates = [
    ...new Set(allInstitutes.map((item) => item.state).filter(Boolean)),
  ];

  // Helper function to get current financial year
  const getCurrentFinancialYear = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;

    if (currentMonth >= 4) {
      return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
    } else {
      return `${currentYear - 1}-${currentYear.toString().slice(-2)}`;
    }
  };

  // Function to check Terms availability for a specific institute
  const checkTermsAvailability = async (institute) => {
    if (!institute.createdBy) {
      console.log(`Institute ${institute.name} has no createdBy field`);
      return false;
    }
    console.log("tabFromUrl:", tabFromUrl);
    try {
      const currentFinancialYear = getCurrentFinancialYear();
      console.log("currentFinancialYear:", currentFinancialYear);

      const termsUrl = `${SERVER_ORIGIN}/api/terms/auth/active/${currentFinancialYear}/${activeTab}`;

      // const termsUrl = `${SERVER_ORIGIN}/api/terms/auth/active/${institute.createdBy}/${currentFinancialYear}`;

      const response = await fetch(termsUrl, {
        headers: {
          "auth-token": sessionStorage.getItem("token"),
        },
      });

      const responseText = await response.text();
      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (parseError) {
        console.log(
          `Could not parse response as JSON for ${institute.name}:`,
          parseError
        );
      }

      let isAvailable = false;

      if (response.status === 200) {
        if (responseData && responseData.data) {
          const termsArray = responseData.data;
          if (Array.isArray(termsArray) && termsArray.length > 0) {
            isAvailable = true;
          } else if (termsArray && !Array.isArray(termsArray)) {
            isAvailable = true;
          } else {
            isAvailable = false;
          }
        } else {
          isAvailable = false;
        }
      } else if (response.status === 404) {
        isAvailable = false;
      } else {
        isAvailable = false;
      }

      return isAvailable;
    } catch (error) {
      console.error(
        "Error checking terms availability for",
        institute.name,
        ":",
        error
      );
      return false;
    }
  };

  // Function to check Terms availability for all institutes
  const checkAllTermsAvailability = async (institutes) => {
    console.log(
      "Checking Terms availability for",
      institutes.length,
      "institutes"
    );
    const availability = {};

    const promises = institutes.map(async (institute) => {
      const isAvailable = await checkTermsAvailability(institute);
      availability[institute._id] = isAvailable;
    });

    await Promise.all(promises);
    setTermsAvailability(availability);
  };

  // Function to calculate Terms availability statistics
  const getTermsStatistics = () => {
    const availabilityValues = Object.values(termsAvailability);
    const totalInstitutes = availabilityValues.length;
    const availableCount = availabilityValues.filter(
      (isAvailable) => isAvailable === true
    ).length;
    const notAvailableCount = availabilityValues.filter(
      (isAvailable) => isAvailable === false
    ).length;

    return {
      total: totalInstitutes,
      available: availableCount,
      notAvailable: notAvailableCount,
    };
  };

  // Function to calculate Email Status statistics from filtered data
  const getEmailStatusStatistics = () => {
    const emailSent = allInstitutes.filter(
      (institute) => institute.emailSentStatus === "sent"
    ).length;
    const emailNotSent = allInstitutes.filter(
      (institute) =>
        institute.emailSentStatus === "not_sent" || !institute.emailSentStatus
    ).length;

    return {
      sent: emailSent,
      notSent: emailNotSent,
      total: allInstitutes.length,
    };
  };

  // Function to calculate Onboarding Status statistics from filtered data
  const getOnboardingStatusStatistics = () => {
    const onboarded = allInstitutes.filter(
      (institute) => institute.onboardingSatus === "onboarded"
    ).length;
    const invited = allInstitutes.filter(
      (institute) => institute.onboardingSatus === "invited"
    ).length;
    const pending = allInstitutes.filter(
      (institute) => institute.onboardingSatus === "pending"
    ).length;

    return {
      onboarded: onboarded,
      invited: invited,
      pending: pending,
      total: allInstitutes.length,
    };
  };

  // Debounce search input
  useEffect(() => {
    const handle = setTimeout(
      () => setDebouncedSearch(searchQuery.trim()),
      350
    );
    return () => clearTimeout(handle);
  }, [searchQuery]);

  useEffect(() => {
    async function getAll() {
      setIsLoading(true);

      try {
        const em_id = sessionStorage.getItem("_id");
        const response = await fetch(
          `${SERVER_ORIGIN}/api/em/auth/institute/all?page=${page}&limit=${limit}&search=${debouncedSearch}&sortBy=name&sortType=${sortType === true ? "asc" : "desc"
          }&_t=${Date.now()}&isThalir=${activeTab === "thalir" ? "true" : "false"
          }`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
              "Cache-Control": "no-cache, no-store, must-revalidate",
              Pragma: "no-cache",
              Expires: "0",
            },
            body: JSON.stringify({
              _id: em_id,
              isThalir: activeTab === "thalir" ? true : false,
            }),
          }
        );

        const result = await response.json();
        setIsLoading(false);
        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate("/");
          } else if (response.status === 500) {
            toast.error(result.statusText);
          }
        } else if (response.status === 200) {
          setAllInstitutes(result.filteredInstitutes);
          setTotalPages(result.totalPages);
          setMouStatus(result.filteredInstitutes.mouStatus);

          if (
            result.filteredInstitutes &&
            result.filteredInstitutes.length > 0
          ) {
            checkAllTermsAvailability(result.filteredInstitutes);
          }
        }
      } catch (err) {
        setIsLoading(false);
      }
    }

    setActiveTab(tabFromUrl || "institute");


    getAll();
    // canVisitPage();

  }, [
    page,
    sortType,
    debouncedSearch,
    navigate,
    limit,
    activeTab,
    refreshCounter,
  ]);

  // Fetch Cluster MOU Thalir upload stats for Chapter EM scope
  useEffect(() => {
    const fetchClusterStats = async () => {
      if (activeTab !== "thalir") {
        setClusterUploadStats({});
        return;
      }

      try {
        const response = await fetch(
          `${SERVER_ORIGIN}/api/em/auth/thalir-uploaded-sheets`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
          }
        );

        if (!response.ok) return;

        const result = await response.json();
        if (!result?.data || !Array.isArray(result.data)) return;

        const map = {};
        result.data.forEach((entry) => {
          if (!entry?.instituteId) return;
          map[entry.instituteId] = {
            instituteId: entry.instituteId,
            instituteName: entry.instituteName,
            schoolsCount: entry.schoolsCount || 0,
            totalStudentsFromSheet: entry.totalStudentsFromSheet || 0,
            uploadHistory: entry.uploadHistory || [],
          };
        });

        setClusterUploadStats(map);
      } catch (err) {
        console.error("Error loading Thalir Cluster upload stats (EM):", err);
      }
    };

    fetchClusterStats();
  }, [activeTab, refreshCounter]);

  // Handle filter changes
  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  // Apply filters to data
  const filteredInstitutes = allInstitutes.filter((institute) => {
    return (
      (!filters.region || institute.region === filters.region) &&
      (!filters.state || institute.state === filters.state) &&
      (!filters.onboardingStatus ||
        institute.onboardingSatus === filters.onboardingStatus) &&
      (!filters.emailStatus ||
        institute.emailSentStatus === filters.emailStatus) &&
      (!filters.termsStatus ||
        (filters.termsStatus === "available"
          ? termsAvailability[institute._id]
          : filters.termsStatus === "not_available"
            ? !termsAvailability[institute._id]
            : true))
    );
  });

  // Clear all filters
  const clearAllFilters = () => {
    setFilters({
      region: "",
      state: "",
      onboardingStatus: "",
      emailStatus: "",
      termsStatus: "",
    });
    setSearchQuery("");
  };

  const refreshData = () => {
    setRefreshCounter((prev) => prev + 1);
  };

  const renderOnboardingStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "invited":
        statusColor = yellow[500];
        statusText = "Invited";
        textColor = "black";
        break;
      case "pending":
        statusColor = deepPurple[500];
        statusText = "Pending";
        textColor = "white";
        break;
      case "onboarded":
        statusColor = green[500];
        statusText = "Onboarded";
        textColor = "white";
        break;
      case "approved":
        statusColor = green[500];
        statusText = "Approved";
        textColor = "white";
        break;
      case "rejected":
        statusColor = red[500];
        statusText = "Rejected";
        textColor = "white";
        break;
      case "submitted":
        statusColor = yellow[500];
        statusText = "Submitted";
        textColor = "black";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            borderRadius: "8px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  const renderEmailStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "sent":
        statusColor = green[500];
        statusText = "Sent";
        textColor = "white";
        break;
      case "not sent":
        statusColor = red[500];
        statusText = "Not Sent";
        textColor = "white";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            borderRadius: "8px",
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  // Elevate on hover component for cards
  const ElevateOnHover = ({ children }) => {
    const [hovered, setHovered] = useState(false);
    return (
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          borderRadius: 12,
          background: "#ffffff",
          transition: "box-shadow 200ms ease, transform 200ms ease",
          boxShadow: hovered
            ? "0 8px 24px rgba(16,24,40,.12)"
            : "0 1px 3px rgba(16,24,40,.06)",
          transform: hovered ? "translateY(-2px)" : "none",
        }}
      >
        {children}
      </div>
    );
  };

  // Stat Card Component
  const StatCard = ({ title, value, icon, gradient }) => (
    <ElevateOnHover>
      <div className={css.dashboardCard} style={{ overflow: "hidden" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
          }}
        >
          <h3
            className={css.cardTitle}
            style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}
          >
            {title}
          </h3>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: gradient,
              color: "#fff",
            }}
          >
            <FontAwesomeIcon icon={icon} />
          </div>
        </div>
        <div
          className={css.cardContent}
          style={{ paddingTop: 0, padding: "0 16px 16px" }}
        >
          <div
            style={{ fontSize: "24px", fontWeight: "600", color: "#1f2937" }}
          >
            {value}
          </div>
        </div>
      </div>
    </ElevateOnHover>
  );

  const rows = filteredInstitutes.map((institute, idx) => ({
    ...institute,
    id: idx + 1,
  }));

  const entityName = activeTab === "institute" ? "College" : "School";

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
    },
    {
      field: "name",
      headerName: `${entityName} Name`,
      width: 220,
    },
    {
      field: "officerName",
      headerName: "Coordinator Name",
      width: 180,
    },
    {
      field: "officerNumber",
      headerName: "Coordinator Number",
      width: 180,
    },
    {
      field: "officerEmail",
      headerName: "Coordinator Email",
      width: 200,
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 150,
    },
    {
      field: "city",
      headerName: "City",
      width: 120,
    },
    {
      field: "state",
      headerName: "State",
      width: 140,
    },
    {
      field: "region",
      headerName: "Region",
      width: 140,
    },
    {
      field: "chapterName",
      headerName: "Chapter Name",
      width: 160,
    },
    {
      field: "country",
      headerName: "Country",
      width: 130,
    },
    {
      field: "mouDuration",
      headerName: "Terms Status",
      width: 150,
      renderCell: (params) => {
        const { signDate, termsAcceptanceDate } = params.row;

        let statusText = "Pending";
        let statusClass = css.notAvailableStatus;

        if (!signDate && !termsAcceptanceDate) {
          statusText = "Not Accepted";
          statusClass = css.notAvailableStatus;
        } else if (signDate && !termsAcceptanceDate) {
          statusText = "Accepted";
          statusClass = css.acceptedStatus;
        } else if (signDate && termsAcceptanceDate) {
          statusText = "Approved";
          statusClass = css.availableStatus;
        }

        return <span className={statusClass}>{statusText}</span>;
      },
    },
    {
      field: "studentCount",
      headerName: "Student Count",
      width: 140,
    },
    ...(activeTab !== "thalir"
      ? [
        {
          field: "yuvaEcAssigned",
          headerName: "YUVA EC Assigned",
          width: 150,
          renderCell: (params) => {
            const isAssigned = Boolean(params.row.yuvaEcAssigned);
            const count = params.row.yuvaEcCount || 0;
            const label = isAssigned ? (count > 0 ? `Yes (${count})` : "Yes") : "No";
            return (
              <button
                type="button"
                onClick={() =>
                  navigate(
                    `/admin/institute-students/${params.row._id}?yuvaEcOnly=1`
                  )
                }
                title="View YUVA EC assigned students"
                className="btn btn-link p-0"
                style={{ textDecoration: "none", lineHeight: 1 }}
              >
                <span
                  style={{
                    background: isAssigned ? "#28a745" : "#f1f1f1",
                    color: isAssigned ? "#fff" : "#555",
                    padding: "4px 10px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: 500,
                    display: "inline-block",
                  }}
                >
                  {label}
                </span>
              </button>
            );
          },
        },
      ]
      : []),
    // {
    //   field: "yuvaEcAssigned",
    //   headerName: "YUVA EC Assigned",
    //   width: 150,
    //   valueGetter: (params) => (params.row.yuvaEcAssigned ? "Yes" : "No"),
    // },
    {
      field: "lastLoginDate",
      headerName: "Last Login",
      width: 180,
      valueFormatter: (params) => {
        if (!params.value) return "Never";
        const date = new Date(params.value);
        return date.toLocaleString("en-gb", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
    },
     {
      field: "updatedAt",
      headerName: "Last Updated",
      align: "center",
      width: 140,
      valueGetter: (params) => params.row.updatedAt || params.row.createdAt || null,
      valueFormatter: (params) => {
        if (!params.value) return "-";
        const d = new Date(params.value);
        return d.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
      renderCell: (params) => (
        <span style={{ whiteSpace: "normal", lineHeight: 1.3 }}>
          {params.formattedValue || params.value || "-"}
        </span>
      ),
    },
    // {
    //   field: "emailSentStatus",
    //   headerName: "Email Sent Status",
    //   width: 160,
    //   renderCell: renderEmailStatus,
    // },
    {
      field: "onboardingSatus",
      headerName: "Onboarding Status",
      width: 160,
      renderCell: renderOnboardingStatus,
    },
    {
      field: "mouStatus",
      headerName: "Terms & Conditions",
      width: 180,
      renderCell: (params) => (
        <TermsAndConditionsButton
          instituteId={params.row._id}
          text="View Terms"
          tabFromUrl={activeTab}
        />
      ),
    },
    {
      field: "editDetails",
      headerName: "Edit",
      type: "actions",
      width: 120,
      align: "center",
      renderCell: (params) => (
        <button
          className={css.viewBtn}
          onClick={() =>
            navigate(
              `/institutes/insert?edit=true&id=${encodeURIComponent(
                params.row._id
              )}&tab=${activeTab}`
            )
          }
        >
          Edit
        </button>
      ),
    },
    {
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        const isThalirCluster =
          activeTab === "thalir" && params.row.moutype === "Cluster MOU";
        const stats = isThalirCluster
          ? clusterUploadStats[params.row._id]
          : null;

        const handleOpenClusterModal = () => {
          console.log("Cluster stats for", params.row.name, ">>", stats);
          // if (!stats) {
          //   toast.error(
          //     "No uploaded schools data found yet for this Cluster MOU institute."
          //   );
          //   return;
          // }
          setClusterModalData({
            instituteName: params.row.name,
            chapterName: params.row.chapterName,
            region: params.row.region,
            city: params.row.city,
            ...stats,
          });
          setClusterModalOpen(true);
        };

        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <InstituteDropDown _id={params.row._id} activeTab={activeTab} />
            {isThalirCluster && (
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={handleOpenClusterModal}
                style={{ whiteSpace: "nowrap" }}
              >
                View Upload Summary
              </button>
            )}
          </div>
        );
      },
    },
  ];

  function handleInstitutesClick() {
    const _id = sessionStorage.getItem("_id");
    navigate(`/institutes/insert?tab=${activeTab}&em_id=${_id}`);
  }

  function CustomColumnMenu(props) {
    return <GridColumnMenu {...props} slotProps={{}} />;
  }

  const stats = {
    total: filteredInstitutes.length,
    terms: getTermsStatistics(),
    email: getEmailStatusStatistics(),
    onboarding: getOnboardingStatusStatistics(),
  };

  return (
    <div className={css.outerDiv}>
      <div className={css.headerSection}>
        <div className={css.headerLeft}>
          <BackButton
            text="Back to Dashboard"
            customPath={getDashboardPath()}
          />
        </div>
      </div>

      {isReadOnly && (
        <div className={css.readOnlyAlert}>
          <div className="alert alert-info" role="alert">
            <strong>Read-Only Access:</strong> You can view all{" "}
            {activeTab === "institute" ? "colleges" : "schools"} data but cannot
            add, edit, or delete any records.
          </div>
        </div>
      )}

      {/* Tab Navigation */}
      <div className="my-4">
        <SecCard>
          <div
            className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
          >
            <div className={css.serviceName}>
              {activeTab === "institute" ? "College Data" : "School Data"}
            </div>
            <div className="d-flex gap-2">
              <div className={`${css.headerRight} d-flex align-items-center gap-3`} style={{ marginTop: "1rem" }}>
                {!isReadOnly && (
                  <>
                    <button
                      // className={css.addBtn}
                      className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 shadow-sm"
                      onClick={handleInstitutesClick}
                    >
                      <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
                      Add {entityName}
                    </button>
                    {activeTab === "thalir" && (
                      <button
                        className="btn btn-outline-primary d-flex align-items-center gap-2 px-4 py-2 shadow-sm"
                        onClick={() => setShowUploadModal(true)}
                        style={{ borderRadius: "0.75rem" }}
                      >
                        <i className="fas fa-file-excel"></i>
                        Upload Excel
                      </button>
                    )}
                    {showUploadModal && activeTab === "thalir" && (
                      <Modal
                        show={showUploadModal}
                        onHide={() => {
                          setShowUploadModal(false);
                          setSelectedFile(null);
                          setSelectedEM(null);
                        }}
                        size="lg"
                        centered
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Bulk Upload Schools</Modal.Title>
                        </Modal.Header>

                        <Modal.Body className="p-4">
                          {/* 1. Download sample */}
                          <div className="mb-5">
                            <h6 className="fw-bold mb-3">1. Download sample template</h6>
                            <p className="text-muted small mb-3">
                              Use this format to avoid upload errors.
                            </p>
                            <DownloadSchoolExcel>
                              <button type="button" className="btn btn-outline-primary">
                                <i className="fas fa-download me-2"></i>
                                Download Sample Excel
                              </button>
                            </DownloadSchoolExcel>
                          </div>

                          <hr className="my-4" />

                          {/* 2. EM selection – ONLY shown if NOT logged in as EM */}
                          {userType !== "em" && (
                            <div className="mb-4">
                              <label className="form-label fw-bold">
                                Assign schools to Chapter EM <span className="text-danger">*</span>
                              </label>
                              <select
                                className="form-select"
                                value={selectedEM?.value || ""}
                                onChange={(e) => {
                                  const em = chapterEMs.find((opt) => opt.value === e.target.value);
                                  setSelectedEM(em || null);
                                }}
                              >
                                <option value="">— Select Chapter EM —</option>
                                {chapterEMs.map((em) => (
                                  <option key={em.value} value={em.value}>
                                    {em.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          {/* 3. File upload area */}
                          <div>
                            <h6 className="fw-bold mb-3">3. Select Excel file</h6>

                            <SchoolUpload
                              emId={userType !== "em" ? selectedEM?.value : undefined}
                              onSuccess={() => {
                                refreshData();
                                setShowUploadModal(false);
                                setSelectedFile(null);
                                setSelectedEM(null);
                              }}
                            >
                              {({ handleFileRetrieve, handleFileUpload, fileUploaded, isUploading }) => (
                                <div className="mt-3">
                                  <div
                                    className={`border rounded p-5 text-center position-relative ${fileUploaded ? "border-success bg-success-subtle" : "border-dashed bg-light"
                                      }`}
                                    style={{ minHeight: "160px", cursor: "pointer" }}
                                    onClick={() => document.getElementById("fileInputModal")?.click()}
                                  >
                                    {fileUploaded ? (
                                      <>
                                        <i className="fas fa-file-excel fa-3x text-success mb-3"></i>
                                        <p className="fw-bold mb-1">File selected</p>
                                        {selectedFile && (
                                          <small className="text-muted">
                                            {selectedFile.name} • {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                                          </small>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <i className="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                                        <p className="mb-1 fw-medium">Click here or drag & drop Excel file</p>
                                        <small className="text-muted">.xlsx or .xls only</small>
                                      </>
                                    )}

                                    <input
                                      id="fileInputModal"
                                      type="file"
                                      accept=".xlsx,.xls"
                                      onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        if (file) {
                                          setSelectedFile(file);
                                          handleFileRetrieve(e);
                                        }
                                      }}
                                      style={{
                                        position: "absolute",
                                        inset: 0,
                                        opacity: 0,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>

                                  <button
                                    className="btn btn-primary w-100 mt-4 py-2"
                                    onClick={handleFileUpload}
                                    disabled={!fileUploaded || isUploading || (userType !== "em" && !selectedEM?.value)}
                                  >
                                    {isUploading ? (
                                      <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Uploading...
                                      </>
                                    ) : (
                                      "Upload Schools Data"
                                    )}
                                  </button>
                                </div>
                              )}
                            </SchoolUpload>
                          </div>
                        </Modal.Body>

                        <Modal.Footer>
                          <button className="btn btn-outline-secondary px-4" onClick={() => setShowUploadModal(false)}>
                            Close
                          </button>
                        </Modal.Footer>
                      </Modal>
                    )}
                  </>


                )}
              </div>
            </div>
          </div>
          {/* <div
            className={`${css.serviceHeader} d-flex justify-content-between align-items-center px-4 py-4 bg-white rounded-top shadow-sm mb-4`}
            style={{
              borderBottom: '1px solid #e5e7eb',
              background: 'linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)',
            }}
          >
            <div>
              <h3 className="fw-bold mb-1 text-gray-900" style={{ fontSize: '1.5rem' }}>
                {activeTab === "institute" ? "College Data" : "School Data"}
              </h3>
              <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
                Manage all {entityName.toLowerCase()} records
              </p>
            </div>

            {!isReadOnly && (
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-outline-secondary d-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                    onClick={handleInstitutesClick}
                    style={{
                      background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '0.625rem',
                      transition: 'all 0.2s ease',
                      borderRadius: '0.625rem',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 10px 25px -5px rgba(99, 102, 241, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0,0,0,0.1)';
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} style={{ fontSize: '1.1rem' }} />
                    Add {entityName}
                  </button>
                </div>

                {activeTab === "thalir" && (
                  <div className="d-flex gap-2">
                    <SchoolUpload onSuccess={refreshData}>
                      <button
                        type="button"
                        className="btn btn-outline-secondary d-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                        style={{
                          borderRadius: '0.625rem',
                          borderColor: '#d1d5db',
                          color: '#4b5563',
                          transition: 'all 0.2s ease',
                        }}
                      >
                        <i className="fas fa-upload" style={{ fontSize: '1rem' }}></i>
                        Upload Excel
                      </button>
                    </SchoolUpload>

                    <DownloadSchoolExcel>
                      <button
                        type="button"
                        className="btn btn-outline-secondary d-flex align-items-center gap-2 px-3 py-2 shadow-sm"
                        style={{
                          borderRadius: '0.625rem',
                          borderColor: '#d1d5db',
                          color: '#4b5563',
                          transition: 'all 0.2s ease',
                        }}
                      >
                        <i className="fas fa-download" style={{ fontSize: '1rem' }}></i>
                        Download Sample
                      </button>
                    </DownloadSchoolExcel>
                  </div>
                )}
              </div>
            )}
          </div> */}

          <Row className="g-4">
            <Col md={6} lg={3} sm={12} xs={12}>
              <StatCard
                title={
                  activeTab === "institute"
                    ? "Total Colleges"
                    : "Total Schools"
                }
                value={stats.total}
                icon={faSchool}
                gradient="linear-gradient(135deg,#6366f1,#8b5cf6)"
              />
            </Col>

            <Col md={6} lg={3} sm={12} xs={12}>
              <StatCard
                title="Terms & Conditions"
                value={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Available
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#2e7d32",
                        }}
                      >
                        {stats.terms.available}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Not Available
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#c62828",
                        }}
                      >
                        {stats.terms.notAvailable}
                      </span>
                    </div>
                  </div>
                }
                icon={faFileSignature}
                gradient="linear-gradient(135deg,#f59e0b,#f97316)"
              />
            </Col>

            <Col md={6} lg={3} sm={12} xs={12}>
              <StatCard
                title="Email Status"
                value={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Sent
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#2e7d32",
                        }}
                      >
                        {stats.email.sent}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Not Sent
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#c62828",
                        }}
                      >
                        {stats.email.notSent}
                      </span>
                    </div>
                  </div>
                }
                icon={faEnvelope}
                gradient="linear-gradient(135deg,#10b981,#34d399)"
              />
            </Col>

            <Col md={6} lg={3} sm={12} xs={12}>
              <StatCard
                title="Onboarding Status"
                value={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Onboarded
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#2e7d32",
                        }}
                      >
                        {stats.onboarding.onboarded}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Invited
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#1976d2",
                        }}
                      >
                        {stats.onboarding.invited}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "11px",
                          color: "#6b7280",
                          marginBottom: "2px",
                        }}
                      >
                        Pending
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#f57c00",
                        }}
                      >
                        {stats.onboarding.pending}
                      </span>
                    </div>
                  </div>
                }
                icon={faUserCheck}
                gradient="linear-gradient(135deg,#06b6d4,#3b82f6)"
              />
            </Col>
          </Row>
        </SecCard>
      </div>

      {/* Search and Filters Section */}
      <div className={css.searchFiltersSection}>
        <div className={css.filtersContainer}>
          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Search</label>
            <div className={css.searchInputWrapper}>
              <input
                type="text"
                value={searchQuery}
                placeholder="Search here.."
                onChange={(e) => setSearchQuery(e.target.value)}
                className={css.searchInput}
              />
              {/* <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className={css.searchIcon}
              /> */}
            </div>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Region</label>
            <select
              value={filters.region}
              onChange={(e) => handleFilterChange("region", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All Regions</option>
              {uniqueRegions.map((region) => (
                <option key={region} value={region}>
                  {region}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>State</label>
            <select
              value={filters.state}
              onChange={(e) => handleFilterChange("state", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All States</option>
              {uniqueStates.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Email Status</label>
            <select
              value={filters.emailStatus}
              onChange={(e) =>
                handleFilterChange("emailStatus", e.target.value)
              }
              className={css.filterSelect}
            >
              <option value="">All Status</option>
              <option value="sent">Sent</option>
              <option value="not sent">Not Sent</option>
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Terms Status</label>
            <select
              value={filters.termsStatus}
              onChange={(e) =>
                handleFilterChange("termsStatus", e.target.value)
              }
              className={css.filterSelect}
            >
              <option value="">All Status</option>
              <option value="available">Available</option>
              <option value="not_available">Not Available</option>
            </select>
          </div>

          <button onClick={clearAllFilters} className={css.clearFiltersBtn}>
            Clear All
          </button>
        </div>
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div className={css.dataGridContainer}>
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            density="compact"
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
            sx={{
              borderRadius: 2,
              border: "1px solid #e5e7eb",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f9fafb",
                color: "#111827",
                fontWeight: 600,
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#fcfcfd",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#eef2ff",
              },
            }}
            slots={{ columnMenu: CustomColumnMenu, toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 300 },
              },
            }}
            loading={isLoading}
          />
        </div>
      )}

      {/* Cluster MOU Thalir upload summary modal */}
      <Modal
        show={clusterModalOpen}
        onHide={() => setClusterModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Cluster MOU – Uploaded Data Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {clusterModalData ? (
            <>
              <p>
                <strong>Institute:</strong> {clusterModalData.instituteName}
              </p>
              {clusterModalData.chapterName && (
                <p>
                  <strong>Chapter:</strong> {clusterModalData.chapterName}
                </p>
              )}
              <p>
                <strong>Location:</strong>{" "}
                {[clusterModalData.city, clusterModalData.region]
                  .filter(Boolean)
                  .join(", ")}
              </p>
              <hr />
              <p>
                <strong>Total Schools (from uploaded sheets):</strong>{" "}
                {clusterModalData.schoolsCount ?? 0}
              </p>
              <p>
                <strong>Total Students (from sheets):</strong>{" "}
                {clusterModalData.totalStudentsFromSheet ?? 0}
              </p>
              {clusterModalData.uploadHistory &&
                clusterModalData.uploadHistory.length > 0 && (
                  <>
                    <hr />
                    <p>
                      <strong>Recent Uploads:</strong>
                    </p>
                    <ul>
                      {clusterModalData.uploadHistory.map((log, idx) => (
                        <li key={`${log.fileName}-${idx}`}>
                          {log.fileName} – {log.schoolsCount} schools,{" "}
                          {log.totalStudentsFromSheet} students (
                          {new Date(log.uploadedAt).toLocaleString("en-GB")})
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              <p className="text-muted mt-3" style={{ fontSize: "0.9rem" }}>
                Counts are based on Thalir school Excel sheets uploaded for this
                Cluster MOU institute.
              </p>
            </>
          ) : (
            <p>No upload data available for this institute.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setClusterModalOpen(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AllInstitute;
